import {Component, inject, signal, Signal} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {RouterModule} from '@angular/router';

import {LogoAreaComponent} from '../logo-area/logo-area.component';
import {HeadlineSectionComponent} from '../headline-section/headline-section.component';
import {ContextService} from '../../services/context.service';
import {Organization} from '../../types-repository';
import {GET_ASPERA_ENDPOINTS} from '../../queries-aspera';
import {Endpoint} from '../../types-aspera';
import {deliveryLabel} from './aspera-rows';

export interface EndpointListRow {
  id: string;
  name: string;
  share: string;
  delivers: string;
  fixedEgressIp: string | null;
}

export function toEndpointRow(endpoint: Endpoint): EndpointListRow {
  return {
    id: endpoint.id,
    name: endpoint.name,
    share: endpoint.shareId != null ? `${endpoint.server} · share ${endpoint.shareId}` : `${endpoint.server} (direct)`,
    delivers: deliveryLabel(endpoint),
    fixedEgressIp: endpoint.fixedEgressIp ?? null,
  };
}

@Component({
  selector: 'app-aspera-endpoints',
  templateUrl: './aspera-endpoints.component.html',
  styleUrls: ['./aspera-endpoints.component.scss'],
  imports: [LogoAreaComponent, HeadlineSectionComponent, RouterModule]
})
export class AsperaEndpointsComponent {
  organization: Signal<Organization>;
  endpoints = signal<EndpointListRow[]>([]);
  loading = signal(true);
  error = signal<string | null>(null);

  private apollo = inject(Apollo);

  constructor(contextService: ContextService) {
    this.organization = contextService.organization;
    this.apollo.use('aspera')
      .query<{ endpoints: Endpoint[] }>({query: GET_ASPERA_ENDPOINTS, fetchPolicy: 'network-only'})
      .subscribe({
        next: ({data}) => {
          this.endpoints.set((data?.endpoints ?? []).map(toEndpointRow));
          this.loading.set(false);
        },
        error: (err) => {
          this.error.set(err?.message ?? String(err));
          this.loading.set(false);
        }
      });
  }
}
